export default __webpack_public_path__ + "static/media/logo-sm.5c6de95e.png";